import PropTypes from 'prop-types';
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import blueMetal from '../assets/images/blue-metal.png';
import greenMetal from '../assets/images/green-metal.png';
import pinkMetal from '../assets/images/pink-metal.png';
import purpleMetal from '../assets/images/purple-metal.png';

type AuthLayoutProps = {
  children: ReactNode;
};

const StyledDiv = styled.div`
  background-image: url(${blueMetal}), url(${greenMetal}), url(${pinkMetal}),
    url(${purpleMetal});
  background-position: left -1% top -15%, right -7.5% top -1%,
    left -5% bottom -10%, right -5% bottom -5%;
  background-repeat: no-repeat, no-repeat, no-repeat, no-repeat;
  background-size: 15%, 15%, 15%, 15%;
`;

const AuthLayout = ({ children }: AuthLayoutProps) => (
  <StyledDiv className="min-h-screen flex flex-col items-center overflow-auto bg-primary-700 py-12">
    {children}
  </StyledDiv>
);

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default AuthLayout;
